import { useNavigate } from "react-router";
import { ActionPanel } from "../actionPanel/ActionPanel";
import { Button, Icon } from "@sellar-io/components";
import { OrderCreateInvoiceDialog } from "../../pages/order/modals/OrderCreateInvoiceDialog";
import { useState } from "react";
import { useOrder } from "../../hooks/api/v2/order/useOrder";
import { SpinnerLegacy } from "..";
import { sanitizeEmailArray } from "@sellar-io/common";
import { useRemoteFeatureFlags } from "../../hooks/useRemoteFeatureFlags";
import { PAYMENT_LINK_REF } from "../../constants/routes";

export const OrderVatInvoiceActionPanel = ({
  orderId,
}: {
  orderId: number;
}) => {
  const navigate = useNavigate();
  const [invoiceCreateDialogActive, setInvoiceCreateDialogActive] =
    useState(false);
  const orderQuery = useOrder(orderId);
  const order = orderQuery.data;
  const hasPaymentLink = !!order && Boolean(order.PaymentLink);
  const paymentLinkCode = hasPaymentLink ? order.PaymentLink?.code : null;
  const showPaymentLinkButton = hasPaymentLink && Boolean(paymentLinkCode);
  const isImplicitProformaEnabled =
    useRemoteFeatureFlags().isActive("implicitProforma");

  // When the implicit proforma flag is active the invoice row in the new status
  // card shows a "View >" button. The dialog is owned by OrderSummaryStatus in
  // that path, so there's nothing to render here.
  if (isImplicitProformaEnabled) {
    return null;
  }

  return (
    <>
      <ActionPanel
        className={"flex flex-col gap-4"}
        title={"Your VAT invoice is available"}
      >
        <div className={"flex flex-col gap-2 md:flex-row"}>
          {!order ? (
            <SpinnerLegacy />
          ) : (
            <>
              <Button
                loading={!order}
                className={"w-full md:w-min"}
                onClick={() => setInvoiceCreateDialogActive(true)}
              >
                <Icon icon="FILE_DOCUMENT_ARROW_RIGHT_OUTLINE" />
                Access Vat Invoice
              </Button>
              {showPaymentLinkButton && (
                <Button
                  onClick={() => {
                    if (!paymentLinkCode) return;
                    navigate(PAYMENT_LINK_REF.href({ code: paymentLinkCode }));
                  }}
                  className={"w-full md:w-min"}
                  color={"secondary"}
                >
                  <Icon size={0.7} icon={"CREDIT_CARD"} />
                  View payment link
                </Button>
              )}
            </>
          )}
        </div>
      </ActionPanel>
      {order && (
        <OrderCreateInvoiceDialog
          active={invoiceCreateDialogActive}
          orderId={orderId}
          onDismiss={() => setInvoiceCreateDialogActive(false)}
          retailerInvoiceEmails={
            !!order.retailerInvoiceEmails?.length
              ? order.retailerInvoiceEmails
              : sanitizeEmailArray(order.Retailer.Business.invoiceEmails)
          }
        />
      )}
    </>
  );
};
